import React, { useState } from 'react';
import Content from '../../../layout/content/Content';
import TablePageHeading from '../../components/page_heading/TablePageHeading';
import Head from '../../../layout/head/Head';
import CardTabs from '../../components/cards/CardTabs';
import * as app_consts from "../../../utils/app_consts";
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import TableList from '../../components/table/TableList';

const WarehouseInventory = ({ tenant_info, user_info }) => {

 const [activeCardTab, setActiveCardTab] = useState("All");
 const [loading, setLoading] = useState(false);
 const [page_data, setPageData] = useState([]);
 const [error, setError] = useState("");
 const [available_stock, settAvailableStock] = useState([]);
 const [out_of_stock, settOutOfStock] = useState([]);

 const tabs = [
  {
   tabName: "All"
  },
  {
   tabName: "Available Stock"
  },
  {
   tabName: "Out of Stock"
  },
 ];

 // Retrieve Warehouse Inventory
 const retrieve_warhouse_inventory = () => {

 };

 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Warehouse Sites` : " Warehouse Sites"} />
   <Content>
    {/* Table Page Heading */}
    <TablePageHeading
     title="Warehouse Inventory"
     // description={activeCardTab === "Physical Warehouse Sites" ? physical_warehouses?.length > 0 && `Total Physical Warehouse Sites: ${physical_warehouses?.length}` : activeCardTab === "Virtual Warehouse Sites" ? virtual_warehouses?.length > 0 && `Total Virtual Warehouse Sites: ${virtual_warehouses?.length}` : ""}
     refresh={!loading}
     refreshFunc={retrieve_warhouse_inventory}
     // csv_export={!loading && !error}
     // add_to_list={loading ? "" : user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_WAREHOUSE_SITE)}
     user_roles={user_info?.roles}
     page_type={app_consts.WAREHOUSE_INVENTORY_MAIN}
     pageData={page_data}
    // openAddList={openAddListModal}
    />
    <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
    {
     loading ?
      <>
       <AuthTenantLoader tenant_info={tenant_info} />
      </>
      :
      <>
       {
        error ?
         <>
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
         </>
         :
         <>
          {
           activeCardTab === "All" && (
            <>
             <TableList
              // left_head_select
              type={app_consts.WAREHOUSE_INVENTORY_MAIN}
              data={page_data}
             // rowOptionsData={componentData}
             // amendFunc={amend_Account_Status_modal}
             // setOpendModalDetails={setOpendModalDetails}
             // setSelectedData={setSelectedUser}
             />
            </>
           )
          }
          {
           activeCardTab === "Available Stock" && (
            <>
             <TableList
              // left_head_select
              type={app_consts.WAREHOUSE_INVENTORY_MAIN}
              data={available_stock}
             // rowOptionsData={componentData}
             // amendFunc={amend_Account_Status_modal}
             // setOpendModalDetails={setOpendModalDetails}
             // setSelectedData={setSelectedUser}
             />
            </>
           )
          }
          {
           activeCardTab === "Out of Stock" && (
            <>
             <TableList
              // left_head_select
              type={app_consts.WAREHOUSE_INVENTORY_MAIN}
              data={out_of_stock}
             // rowOptionsData={componentData}
             // amendFunc={amend_Account_Status_modal}
             // setOpendModalDetails={setOpendModalDetails}
             // setSelectedData={setSelectedUser}
             />
            </>
           )
          }
         </>
       }
      </>
    }
   </Content>

  </>
 );
};

export default WarehouseInventory;